/**
 * v-z-index=[value]
 * v-cursor=[value]
 */
export default (Vue) => {
  Vue.directive('order', (el, { value, arg }) => {
    el.style.order = arg || value;
  });

  Vue.directive('z-index', (el, { value }) => {
    el.style.zIndex = value;
  });

  Vue.directive('cursor', (el, { arg, value }) => {
    el.style.cursor = arg || value || '';
  });

  Vue.directive('display', (el, { arg, value }) => {
    el.style.display = arg || value || '';
  });

  ['overflow', 'overflow-y', 'overflow-x'].forEach((item) => {
    Vue.directive(item, (el, { arg, value }) => {
      el.style[item] = arg || value || '';
    });
  });

  Vue.directive('white-space', (el, { arg, value }) => {
    el.style.whiteSpace = arg || value || '';
  });

  Vue.directive('vertical-align', (el, { arg, value }) => {
    el.style.verticalAlign = arg || value || '';
  });

  Vue.directive('overflow-wrap', (el, { arg, value }) => {
    el.style.overflowWrap = arg || value || '';
  });

  Vue.directive('word-break', (el, { arg, value }) => {
    el.style.wordBreak = arg || value || '';
  });

  Vue.directive('opacity', (el, { arg, value }) => {
    const val = arg || value;
    el.style.opacity = typeof val !== 'undefined' ? val : '';
  });

  Vue.directive('pointer-events', (el, { arg, value }) => {
    el.style.pointerEvents = arg || value || '';
  });

  Vue.directive('text-decoration', (el, { arg, value }) => {
    el.style.textDecoration = arg || value || '';
  });

  Vue.directive('text-align', (el, { arg, value }) => {
    el.style.textAlign = arg || value || '';
  });

  Vue.directive('border-radius', (el, { arg, value }) => {
    const val = arg || value;
    el.style.borderRadius = typeof val !== 'undefined' ? val : '';
  });
};
